import { render, staticRenderFns } from "./ChatListItem.vue?vue&type=template&id=596db02b&scoped=true&"
import script from "./ChatListItem.vue?vue&type=script&lang=js&"
export * from "./ChatListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatListItem.vue?vue&type=style&index=0&id=596db02b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596db02b",
  null
  
)

export default component.exports